import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class OrgUnits extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			UNIT_NAME: '',
			COMMENTS: ''
		};
		
		var initialOrgUnitList = this.copyOrgUnitList();
		initialOrgUnitList.query.search = this.constructSearch(search);
		
		this.state = {
			renderKey: 1,
			orgUnitList: initialOrgUnitList,
			search: search,
			searchCount: null
		};
	}
	
	copyOrgUnitList() {
		var orgUnitListCopy = this.copyObject(orgUnitList);
		for (var i = 0; i < orgUnitList.columns.length; i++) {
			if (orgUnitList.columns[i].Header) {
				orgUnitListCopy.columns[i].Header = orgUnitList.columns[i].Header;
			}
			if (orgUnitList.columns[i].Cell) {
				orgUnitListCopy.columns[i].Cell = orgUnitList.columns[i].Cell;
			}
		}
		return orgUnitListCopy;
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newOrgUnitList = this.copyOrgUnitList();
		newOrgUnitList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			orgUnitList: newOrgUnitList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.UNIT_NAME)) search.Children.push({ Attribute: 'UNIT_NAME', Operator: 'like', StringValue: '%' + data.UNIT_NAME + '%' });
		if (!this.isEmpty(data.COMMENTS)) search.Children.push({ Attribute: 'COMMENTS', Operator: 'like', StringValue: '%' + data.COMMENTS + '%' });
		
		// if nothing was selected, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}
	
	addOrgUnit() {
		this.props.navigate('/BuildingAccess/OrgUnits/new');
	}
	
	editOrgUnit(orgUnitId) {
		this.props.navigate('/BuildingAccess/OrgUnits/' + orgUnitId);		
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Organizational Units',
			columns: exportColumns,
			entity: 'ORG_UNIT_VW',
			search: this.constructSearch(this.state.search),
			order: 'UNIT_NAME'
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Organizational Units</span>
					<ChemEdit parent={this} columns={orgUnitSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_OrgUnits' table={this.state.orgUnitList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='200px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const orgUnitSearch = [
	{ Header: 'Name', accessor: 'UNIT_NAME', row: 0, col: 0 },
	{ Header: 'Comments', accessor: 'COMMENTS', row: 0, col: 1 }
];

const orgUnitList = {
	query: { entity: 'ORG_UNIT_VW', search: null, order: 'UNIT_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addOrgUnit()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editOrgUnit(props.row.values.UNIT_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'UNIT_ID' },
		{ Header: 'Name', accessor: 'UNIT_NAME', width: 300 },
		{ Header: 'Department', accessor: 'DEPT_NAME' },
		{ Header: 'Active', accessor: 'ACTIVE' },
		{ Header: 'Inactive', accessor: 'INACTIVE' }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'UNIT_ID', width: 5 },
	{ Header: 'Name', accessor: 'UNIT_NAME', width: 15 },
	{ Header: 'Department', accessor: 'DEPT_NAME', width: 20 },
	{ Header: 'Active', accessor: 'ACTIVE', width: 5 },
	{ Header: 'Inactive', accessor: 'INACTIVE', width: 5 }
];

export default withRouter(OrgUnits);